var _g, _circle, _circle2, _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384,
    height: 384,
    viewBox: "0 0 384 384",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1586_14580)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 192,
    r: 132,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 192,
    cy: 192,
    r: 132,
    fill: "url(#paint0_angular_1586_14580)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 192.471,
    cy: 192.471,
    r: 72.4706,
    fill: "url(#paint1_angular_1586_14580)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 163.5,
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#008C64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 163.5,
    width: 57,
    height: 57,
    rx: 28.5,
    stroke: "#EDF5F2",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.375 189.897C181.375 184.147 186.18 179.5 191.992 179.5C197.82 179.5 202.625 184.147 202.625 189.897C202.625 192.795 201.571 195.485 199.837 197.764C197.924 200.279 195.565 202.471 192.911 204.191C192.303 204.588 191.755 204.618 191.088 204.191C188.418 202.471 186.06 200.279 184.163 197.764C182.427 195.485 181.375 192.795 181.375 189.897ZM188.494 190.22C188.494 192.147 190.066 193.662 191.993 193.662C193.922 193.662 195.509 192.147 195.509 190.22C195.509 188.309 193.922 186.72 191.993 186.72C190.066 186.72 188.494 188.309 188.494 190.22Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1586_14580",
    x: 0,
    y: 0,
    width: 384,
    height: 384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_1586_14580"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_1586_14580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192 192) rotate(90) scale(132)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009470",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_1586_14580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.471 192.471) rotate(90) scale(72.4706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009470",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMarker);
export default __webpack_public_path__ + "static/media/light-marker.8b77ee440ea4f584ef2e4f7217e47993.svg";
export { ForwardRef as ReactComponent };